import { create } from "zustand";

const useInitialDataQcStore = create((set) => ({
  zustandInitialDataScriptStatus: null,
  setZustandInitialDataScriptStatus: (status) =>
    set({ zustandInitialDataScriptStatus: status }),
}));

export default useInitialDataQcStore;
